import { DeviceCapabilities, DeviceType } from '../types/device'

// Build-time constants for each target — vite.config.ts defines
// `import.meta.env.APP_TARGET` (not VITE_-prefixed) per app.
const APP_TARGET = import.meta.env.APP_TARGET || 'desktop'

const DEVICE_CONFIGS: Record<string, DeviceCapabilities> = {
  desktop: {
    type: DeviceType.DESKTOP,
    hasPhysicalKeypad: false,
    hasHardwareScanner: false,
    screenWidth: 1920,
    screenHeight: 1080,
    isGloveOperable: false,
    thumbZoneHeight: 0,
  },
  mobile: {
    type: DeviceType.MOBILE_TOUCH,
    hasPhysicalKeypad: false,
    hasHardwareScanner: true,
    screenWidth: 540,
    screenHeight: 960,
    isGloveOperable: true,
    thumbZoneHeight: 120,
  },
  mobile_keypad: {
    type: DeviceType.MOBILE_KEYPAD,
    hasPhysicalKeypad: true,
    hasHardwareScanner: true,
    screenWidth: 375,
    screenHeight: 667,
    isGloveOperable: true,
    thumbZoneHeight: 120,
  },
  tablet: {
    type: DeviceType.TABLET,
    hasPhysicalKeypad: false,
    hasHardwareScanner: true,
    screenWidth: 768,
    screenHeight: 1024,
    isGloveOperable: true,
    thumbZoneHeight: 80,
  },
  shipper: {
    type: DeviceType.DESKTOP,
    hasPhysicalKeypad: false,
    hasHardwareScanner: false,
    screenWidth: 1920,
    screenHeight: 1080,
    isGloveOperable: false,
    thumbZoneHeight: 0,
  },
}

export const useDevice = () => {
  const device = DEVICE_CONFIGS[APP_TARGET] || DEVICE_CONFIGS.desktop

  const isMobile = device.type === DeviceType.MOBILE_TOUCH || device.type === DeviceType.MOBILE_KEYPAD
  const isDesktop = device.type === DeviceType.DESKTOP
  const isTablet = device.type === DeviceType.TABLET

  const getGloveSafeSize = (size: number): number => {
    if (!device.isGloveOperable) return size
    return Math.max(size, 12) // Minimum 12px for glove-safe targets
  }

  const getTapTargetHeight = (): number => {
    if (isMobile) return 64 // Mobile minimum (thumb-zone)
    if (isTablet) return 48 // Tablet minimum (glove touch)
    return 32 // Desktop minimum (mouse interaction)
  }

  return {
    device,
    isMobile,
    isDesktop,
    isTablet,
    isShipper: APP_TARGET === 'shipper',
    getGloveSafeSize,
    getTapTargetHeight,
  }
}
